import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-city-office',
  templateUrl: './city-office.component.html',
  styleUrls: ['./city-office.component.scss']
})
export class CityOfficeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
